"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGroupOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30.53 16A15.34 15.34 0 0023 14v2a13.82 13.82 0 016 1.44V20h-2v2h4v-5.7zM3 17.44A13.69 13.69 0 019 16v-2a15.34 15.34 0 00-7.53 2l-.47.3V22h4v-2H3zM16 18a3.34 3.34 0 002.46-.9 4.19 4.19 0 001-3.1c0-3.47-2.19-4-3.5-4a3.41 3.41 0 00-2.47.9 4.17 4.17 0 00-1 3.1c.01 3.47 2.2 4 3.51 4zm-1.06-5.68A1.33 1.33 0 0116 12c.79 0 1.5.16 1.5 2a2.42 2.42 0 01-.44 1.68c-.08.08-.29.3-1.06.32s-1.5-.16-1.5-2a2.4 2.4 0 01.44-1.68zM23.5 12a3.34 3.34 0 002.5-.9A4.17 4.17 0 0027 8c0-3.47-2.19-4-3.5-4a3.38 3.38 0 00-2.5.9A4.17 4.17 0 0020 8c0 3.47 2.19 4 3.5 4zm-1.06-5.68a1.33 1.33 0 011-.32c.79 0 1.5.16 1.5 2a2.42 2.42 0 01-.44 1.68 1.58 1.58 0 01-1 .32c-.79 0-1.5-.16-1.5-2a2.4 2.4 0 01.44-1.68zM8.5 12a3.34 3.34 0 002.5-.9A4.17 4.17 0 0012 8c0-3.47-2.19-4-3.5-4a3.36 3.36 0 00-2.5.9A4.17 4.17 0 005 8c0 3.47 2.19 4 3.5 4zM7.44 6.32a1.33 1.33 0 011-.32c.79 0 1.5.16 1.5 2a2.42 2.42 0 01-.44 1.68 1.58 1.58 0 01-1 .32C7.71 10 7 9.84 7 8a2.4 2.4 0 01.44-1.68zM16 20a15 15 0 00-7.53 1.89l-.47.29V28h16v-5.82l-.47-.29A15 15 0 0016 20zm6 6H10v-2.67A13.71 13.71 0 0116 22a13.83 13.83 0 016 1.33z" })));
}
exports.default = SvgGroupOutline;
//# sourceMappingURL=GroupOutline.js.map